'use client';

import { css } from 'styled-components';
import { whenFocused, whenHovered } from 'utils';
import { theme } from '@frameio/vapor-theme';

export const focusStyles = css`
  box-shadow: 0 0 0 0 transparent;
  ${whenFocused} {
    box-shadow: inset 0 0 0 1px ${theme.colors.border.interactive.focused};
  }
`;

export const INTERACTIVE_TRANSITION_DURATION = 150;

export const hoverTransition = css`
  transition: color 0.15s ${theme.transitions.eases.primary},
    background-color 0.15s ${theme.transitions.eases.primary},
    box-shadow 0.15s ${theme.transitions.eases.primary},
    opacity 0.15s ${theme.transitions.eases.primary};
`;

export const hoverStyles = css<{ $sharedHoverEnabled?: boolean }>`
  ${(p) =>
    !p.$sharedHoverEnabled &&
    `
    background-color: transparent;

    ${whenHovered} {
      background-color: ${theme.colors.background.interactive.hover};
    }
  `}
`;
